 function showFAQ(id) {
  var allFAQSections = document.querySelectorAll('.faq-section-content');
  var allTabs = document.querySelectorAll('.lp-tab-side');

  allFAQSections.forEach(function(section) {
    section.style.display = 'block';
  });
  var activeFAQ = document.getElementById(id);
  if (activeFAQ) {
    activeFAQ.style.display = 'block';
  }
  allTabs.forEach(function(tab) {
    tab.classList.remove('active');
  });
  var clickedTab = document.querySelector(`a[onclick="showFAQ('${id}')"]`);
  if (clickedTab) {
    clickedTab.classList.add('active');
  }
}
  var acc = document.getElementsByClassName('faqs-title');
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener('click', function () {
      this.classList.toggle('active');
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  }

document.addEventListener('DOMContentLoaded', function () {
  const lpTabs = document.querySelector('.lp-faq-Tab');
  const faqNav = document.querySelector('.faq-sction-nav');
  const offset = lpTabs.offsetTop;
  
  let lastScrollTop = 0;

  function handleStickyNav() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    const faqNavOffsetTop = faqNav.offsetTop;
    const faqNavHeight = faqNav.offsetHeight;
    const isInFAQSection = scrollTop >= faqNavOffsetTop && scrollTop <= (faqNavOffsetTop + faqNavHeight);

    if (isInFAQSection && scrollTop > offset) {
      if (!lpTabs.classList.contains('sticky')) {
        lpTabs.classList.add('sticky');
      }
    } else {
      if (lpTabs.classList.contains('sticky')) {
        lpTabs.classList.remove('sticky');
      }
    }

    if (scrollTop > lastScrollTop) {
      if (lpTabs.classList.contains('sticky')) {
        lpTabs.style.top = "5";
      }
    } else {
      if (lpTabs.classList.contains('sticky')) {
        lpTabs.style.top = "5";
      }
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  window.addEventListener('scroll', handleStickyNav);
});

document.addEventListener("DOMContentLoaded", function () {
  const faqSections = document.querySelectorAll(".faq-section-content");
  const faqLinks = document.querySelectorAll(".lp-tab-side");

  const observerOptions = {
    root: null, // Observe in the viewport
    rootMargin: "-30% 0px -60% 0px", // Adjust margins for better detection
    threshold: 0.1, // Trigger when 10% of the section is visible
  };

  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let activeID = entry.target.id;

        faqLinks.forEach((link) => {
          if (link.getAttribute("href") === `#${activeID}`) {
            link.classList.add("active");
          } else {
            link.classList.remove("active");
          }
        });
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);
  faqSections.forEach((section) => observer.observe(section));

  faqLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const targetID = this.getAttribute("href").substring(1);
      const targetSection = document.getElementById(targetID);

      if (targetSection) {
        window.scrollTo({
          top: targetSection.offsetTop - 100,
          behavior: "smooth",
        });
      }

      // Manually update active class on click
      faqLinks.forEach((lnk) => lnk.classList.remove("active"));
      this.classList.add("active");
    });
  });
});
